import tissuePhloemSieveTube from "../../images/tissuePhloemSieveTube.png"
import tissuePhloemFiber from "../../images/tissuePhloemFiber.jpg"

const phloemMarkdown = `
# Phloem

เป็นเนื้อเยื่อที่ทำหน้าที่ลำเลียงอาหารและสร้างความแข็งแรงให้แก่ลำต้นพืช โดยลำเลียงจากใบไปสู่ส่วนต่างๆของพืช เพื่อใช้ในการสร้างพลังงานของพืช ประกอบด้วยเซลล์ 4 ชนิด ดังนี้

## Sieve tube member

เป็นเซลล์ที่มีรูปร่างเป็นทรงกระบอกยาว เป็นเซลล์ที่มีชีวิต ประกอบด้วย ช่องว่างภายในเซลล์ (Vacuole) ขนาดใหญ่มาก เมื่อเซลล์เจริญเติบโตเต็มที่แนิวเคลียสจะสลายไป ผนังเซลล์มีเซลลูโลส (Cellulose) สะสมอยู่เล็กน้อย ทำหน้าที่เป็นทางส่งผ่านของอาหารที่ได้จากกระบวนการสังเคราะห์ด้วยแสงของพืชไปยังส่วนต่างๆ ของลำต้นพืช

## Companion cell

เป็นเซลล์พิเศษที่มีต้นกำเนิดมาจากเซลล์แม่เซลล์เดียวกันกับซีฟทิวบ์เมมเบอร์ เป็นเซลล์ขนาดเล็กที่มีรูปร่างผอมยาว มีลักษณะเป็นเหลี่ยม ส่วนปลายแหลม เป็นเซลล์ที่มีชีวิต มีไซโทพลาซึมที่มีองค์ประกอบของสารเข้มข้นมาก มีเซลลูโลสสะสมอยู่ที่ผนังเซลล์เล็กน้อย และมีรูเล็กๆ เพื่อใช้เชื่อมต่อกับซีฟทิวบ์เมมเบอร์ ทำหน้าที่ช่วยเหลือซีฟทิวบ์เมมเบอร์ให้ทำงานได้ดีขึ้นเมื่อเซลล์มีอายุมากขึ้น

![Sieve tube member and companion cell](tissuePhloemSieveTube)

## Phloem parenchyma

เป็นเซลล์ที่มีชีวิต มีผนังเซลล์บาง มีรูเล็กๆ ที่ผนังเซลล์ โฟลเอ็มพาเรงคิมาทำหน้าที่สะสมอาหารที่ได้จากกระบวนการสังเคราะห์ด้วยแสงของ พืช ลำเลียงอาหารไปยังส่วนต่างๆ ของพืช และเสริมความแข็งแรงให้กับท่อลำเลียงอาหาร

## Phloem fiber

มีลักษณะคล้ายกับไซเล็มไฟเบอร์ มีรูปร่างลักษณะยาว มีหน้าตัดกลมหรือรี ทำหน้าที่ช่วยเสริมความแข็งแรงให้กับท่อลำเลียงอาหารและสะสมอาหารให้แก่พืช

![Phloem parenchyma and phloem fiber](tissuePhloemFiber)
`;

const phloemData = {
  markdown: phloemMarkdown,
  images: {
      tissuePhloemSieveTube,
      tissuePhloemFiber
  }
};

export default phloemData;



// WEBPACK FOOTER //
// ./src/pages/Tissue/Phloem.js